<template>
    <div id="alliance">
        <Header />
        <Login />
        <div class="alliance_box">
            <div class="banner">
                <div class="container">
                    <p>artube WEBTOON</p>
                    <p class="big">검증된 IP로 성공적인<span>비즈니스를 경험해보세요</span></p>
                </div>
            </div>
            <div class="container">
                <div class="question">
                    <p class="title">광고/제휴문의</p>
                    <p>작품성이 검증된 기성작가 신인작가의 판권을 캐릭터 사업, 광고, 게임으로 확장해보세요.</p>
                </div>
                <div class="guide">
                    <p class="title">제휴가이드</p>
                    <div class="guide_box">
                        <p>제휴 제안 등록</p>
                        <img src="../assets/images/icon_right_arrow_purple.svg" alt="화살표">
                        <p>접수</p>
                        <img src="../assets/images/icon_right_arrow_purple.svg" alt="화살표">
                        <p>담당자 검토</p>
                        <img src="../assets/images/icon_right_arrow_purple.svg" alt="화살표">
                        <p>결과 회신</p>
                    </div>
                </div>
                <router-link tag="a" to="/Alliancequestion">광고/제휴 문의</router-link>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Login from '../components/Login.vue'

export default {
    name: 'Home',
        pageCategory: '',
        components: {
            Header,
            Footer,
            Login,
    }
}
</script>